
import type { FC } from 'react';
import { memo, useMemo} from 'react';
import classNames from 'classnames';
import { playAudio, parsingAI } from '@/utils/audioPlay';
import { IObjString, ICollectOptionListItem, IlistItem, IAIDragQuestionProps } from '@/utils/ctype';
import DragAI from '../../../components/DragAI';
import DropAI from '../../../components/DropAI';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';

const Container: FC<IAIDragQuestionProps> = memo(function Container(props) {
  
  const { data, answerMap, groupId, type, keyIndex, answerAllText} = props;
  const { collect_option, list, question_title} = data || {};

  const {collectIdToTitleMap} = useMemo(() => {
    const collectIdToTitleMap :IObjString = {};
    collect_option.list.forEach((item: ICollectOptionListItem) => {
      collectIdToTitleMap[item.id] = item.title;
    }, {});
    return {collectIdToTitleMap };
  }, [collect_option.list]);
  
  const createAIType = (item: IlistItem, answer: string) => {
    const letter = collectIdToTitleMap[answer];
    if (item?.display_answer === letter) {
      return 'success';
    } else {
      return 'fail';
    }
  };

  return (
    <div className={style.box}>
      <div className={style.question}>
        <div className={style.questionTitle}><HtmlParser htmlString={question_title}></HtmlParser></div>
        {list.map((item: IlistItem, index: number) => {
          const key = `${groupId}_${type}_${item.id}`;
          const answer = answerMap[key] && answerMap[key][0];
          const resultType = createAIType(item, answer);
          return (
            <div className={style.questionItem} key={index}>
              <DropAI 
                data={item}
                type={resultType}
                answer={answerAllText[item.number - 1]}
                answerKey={`answerAllText.${item.number - 1}`}
                dataKey={`question.question.${keyIndex}.list.${index}.display_answerHtml`}
                id={`question${item.number}`}
                playAudio={()=> {playAudio(item);}}
                parsingAI={() => {parsingAI(item);}}/>
              <span className={style.questionText} data-key={`question.question.${keyIndex}.list.${index}.title`}>
                <HtmlParser htmlString={item.title}></HtmlParser>
              </span>
            </div>
          );
        })}
      </div>

      <div className={style.answer}>
        <div className={style.optionTitle}><HtmlParser htmlString={collect_option.title}></HtmlParser></div>
        <div className={classNames(style.answerList)}>
          {collect_option.list.map(( data: ICollectOptionListItem , index: number) => (
            <DragAI 
              data={data} 
              optionClass={style.mt15}
              key={index}
              dataKey={`question.question.${keyIndex}.collect_option.list.${index}.content`} 
              titleKey={`$question.question.${keyIndex}.collect_option.list.${index}.title`} 
            />
          ))}
        </div>
      </div>
    </div>
  );
});

export default Container;